<style lang="scss" scoped>
.slide-6 {
  background-image: url("../../../assets/module4/slide6/bg-01.jpg");
  background-size: cover;
  background-position: center;
  height: calc(100% - 106px);
  padding-left: 120px;
  padding-top: 106px;
}
p {
  max-width: 765px;
  color: white;
  line-height: 40px;
}
.content {
  width: 1048px;
  padding-top: 75px;
  display: flex;
  flex-direction: column;
}
.right {
  margin-left: auto;
  width: 500px;
  margin-top: 20px;
}
h1 {
  font-size: 54px;
  line-height: 65px;
  span {
    color: #301e48;
    font-size: 94px;
  }
}
.last {
  margin-top: 50px;
  white-space: nowrap;
}
.wobbly {
  transform: translateY(10px);
  font-size: 61px;
}
</style>

<template>
  <div class="slide-6">
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 5"
        src="@/assets/module4/slide6/sophia-01.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 5"
        src="@/assets/module4/slide6/photo-01.png"
        class="chars delay-2"
      />
    </transition>
    <transition name="scale" appear>
      <p v-show="slideIndex == 5">
        The other three FAST Heroes told you a lot about the Evil Clot that
        causes strokes.
      </p>
    </transition>
    <div class="content">
      <transition name="scale" appear>
        <h1 v-show="slideIndex == 5" class="delay-1">
          IF THE <span>EVIL CLOT</span> STRIKES AT MY BRAIN, IT COULD CAUSE MY
          TWO LIPS TO SUDDENLY FIND IT
          <Wobbly class="wobbly" text="DIFFICULT TO SPEAK" />
        </h1>
      </transition>
      <div class="right">
        <transition name="scale" appear>
          <div v-show="slideIndex == 5" class="delay-3">
            <h1>
              PROPERLY AS IF MY TWO LIPS ARE NOT LISTENING TO THE BRAIN ANYMORE.
            </h1>
            <p class="last">That could be very confusing.</p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Wobbly from "@/components/Wobbly";

export default {
  data() {
    return {
      showVideo: false
    };
  },
  props: ["slideIndex"],
  components: {
    Wobbly
  }
};
</script>
